var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0273438,
    y: 0.166992,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02751 1.5C4.34751 1.5 1.36084 4.48667 1.36084 8.16667C1.36084 11.8467 4.34751 14.8333 8.02751 14.8333C11.7075 14.8333 14.6942 11.8467 14.6942 8.16667C14.6942 4.48667 11.7075 1.5 8.02751 1.5ZM8.69417 11.5H7.36084V10.1667H8.69417V11.5ZM8.69417 8.83333H7.36084V4.83333H8.69417V8.83333Z",
    fill: "#DE1135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAlert);
export default __webpack_public_path__ + "static/media/mapAlert.830c3bff51132f08d453c67540cba234.svg";
export { ForwardRef as ReactComponent };